export default class MainvisualChange {
    constructor() {
        this.init();
    }

    init() {
        this.eventBind();
        this.setImage();
    }

    eventBind() {
        const mainvisual = document.querySelector(".mainvisual");
        const triggers = [...document.querySelectorAll(".js-mvchangebtn")];
        const mainvisualimg = document.querySelector(".img.-top");


        triggers.forEach((el) => {
            el.addEventListener("click", () => {
                const mvid = el.getAttribute("data-mvbtn");

                triggers.forEach((el) => el.classList.remove("-active"));
                el.classList.add("-active");

                mainvisual.setAttribute("data-mv", mvid);

                mainvisual.classList.add("-anim");
            });
        });

        mainvisualimg.addEventListener("animationend", () => {
            mainvisual.classList.remove("-anim");
        });
    }

    setImage() {
        const mvimage = [...document.querySelectorAll(".js-mvchangebtn")];
        const mvlenght = mvimage.length;
        const id = Math.floor(Math.random() * mvlenght) + 1;

        const mv = document.querySelector(".mainvisual");
        mv.setAttribute("data-mv", id);
    }
}